export default __webpack_public_path__ + "static/media/PulleysImg.821abbba.jpg";